export default __webpack_public_path__ + "static/IvarDisplay-Regular-c7cc02b797ded58e4b8c58886f38af46.woff2";